import React, { FC } from 'react';

import { Dispatch } from 'redux';
import { connect } from 'react-redux';

import { Translate } from 'react-localize-redux';

import { ProductPricing } from '@services/merch/types/api/create-product';

import AppState from '@webapp/store/state';
import { ProductSample } from '@webapp/store/merch/state';
import { UpdateMerchProductSample } from '@webapp/store/merch/action-creators';

import Chip from '@components/basics/chip';
import Checkbox from '@components/form/checkbox';

interface ReceiveSampleProductProps {
  receiveSample?: boolean;
  country: string;
  productSample?: ProductSample | null | undefined;
  productPrice?: number;
  pricingData?: ProductPricing;
}
interface ReceiveSampleOrderMapDispatchProps {
  updateSampleOrder: Function;
}

const mapStateToProps = (state: AppState) => {
  const receiveSample = state.merch.active?.productSample
    ? state.merch.active?.productSample?.receiveSample || false
    : false;
  const countryRegion = state?.release?.release
    ? (state?.release.release.regions &&
        state?.release.release.regions[0]?.name) ||
      ''
    : '';
  const productSample = state.merch.active?.productSample;
  const productPrice =
    state.merch.active?.newProduct?.pricing?.production_cost ||
    state.merch.active?.editProduct?.cost;

  return {
    receiveSample: receiveSample,
    country: countryRegion,
    productSample,
    productPrice,
  };
};
const mapDispatchToProps = (dispatch: Dispatch) => ({
  updateSampleOrder: (sampleOrder: ProductSample) =>
    dispatch(new UpdateMerchProductSample(sampleOrder)),
});
const ReceiveSampleProduct: FC<
  ReceiveSampleProductProps & ReceiveSampleOrderMapDispatchProps
> = ({
  receiveSample,
  updateSampleOrder,
  country,
  productSample,
  productPrice,
}) => {
  const updateReceiveSampleOrder = () => {
    const receiveSampleOrder = !receiveSample;
    updateSampleOrder({
      ...productSample,
      receiveSample: receiveSampleOrder,
      shippingDetails: {
        ...productSample?.shippingDetails,
        country,
      },
    });
  };

  if (!productPrice) return null;

  return (
    <Checkbox
      active={receiveSample ? true : false}
      title={<Translate id="MERCH.PRODUCT_SAMPLE.RECEIVE_SAMPLE_TEXT" />}
      hasIcons={
        <Chip hasActive={receiveSample} chipType="success" small>
          ${productPrice?.toFixed(2)}
        </Chip>
      }
      onClick={updateReceiveSampleOrder}
    />
  );
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ReceiveSampleProduct);
